import {
  User,
  UserModel,
  useUserStore
} from '@crimeos-frontend/shared/crime-os-shared'

interface UserType {
  userId: string
  name?: string | null
  profilePicUrl?: string | null
  email?: string | null
}

interface ReturnType {
  setAndCreateUsersModels: (users: UserType[]) => UserModel[]
}

const useHandleUsersResponse = (): ReturnType => {
  const userStore = useUserStore()

  const convertGraphqlToUserModelType = (response: UserType): User => ({
    userId: response.userId,
    profilePicUrl: response.profilePicUrl,
    name: response.name,
    email: response.email || undefined
  })

  const setAndCreateUsersModels = (users: UserType[]): UserModel[] => {
    users.forEach(user => {
      const userModelType = convertGraphqlToUserModelType(user)
      userStore.createOrUpdateUser(userModelType)
    })

    const userModels = users.map(user => userStore.getOrCreateUser(user.userId))

    return userModels
  }

  return {
    setAndCreateUsersModels
  }
}

export default useHandleUsersResponse
